export default __webpack_public_path__ + "static/media/policytracker.63213530.jpg";